import Splide from '@splidejs/splide';

// eslint-disable-next-line import/no-unresolved
import arrowPath from './arrowPath.UNIVERSITY';
import SplideExtension from './SplideExtension';

const init = ( elements ) => {
	elements.forEach( ( el ) => {
		const splide = new Splide( el, {
			arrowPath,
			gap: 'var(--slider-gap)',
		} );
		if ( ! el.classList.contains( 'is-initialized' ) ) {
			splide.mount( { SplideExtension } );
		}
	} );
};

export default init;
